export default __webpack_public_path__ + "static/media/webb_totk.7db5fde3.png";